import { ColumnTypes, EditableCellType } from '@/components';
import {
	ALL_DOCUMENT_OPTIONS,
	DocumentTypeEnum,
	FormError,
	MasterInfoEnum,
	PageTypeEnum,
} from '@/constant';
import { TDefineDocumentAreaDetailStore } from '@/stores';
import {
	insertIf,
	removeFileNameInvalidChars,
	sortByFieldAndLanguage,
} from '@/utils';

import { DefaultOptionType } from 'antd/es/select';

import { TFunction } from 'i18next';
import { includes } from 'ramda';
import * as Yup from 'yup';

import { RelatedInfoOption } from './define-document-area.type';
import RelationDocument from './relation-document';
import TypeNameDocument from './type-name-document';

export const RELATED_INFO_OPTIONS: RelatedInfoOption[] = [
	{
		id: 2,
		label: '사업장',
		value: MasterInfoEnum.FRANCHISE,
		children: [
			PageTypeEnum.UNIT,
			PageTypeEnum.APPLICANT,
			PageTypeEnum.CHANGE_WORK_PLACE,
			PageTypeEnum.EXTENSION_STAY,
		],
		documentType: [
			DocumentTypeEnum.C_0,
			DocumentTypeEnum.C_12,
			DocumentTypeEnum.C_13,
			DocumentTypeEnum.C_14,
			DocumentTypeEnum.C_16,
			DocumentTypeEnum.C_17,
			DocumentTypeEnum.C_18,
			DocumentTypeEnum.C_19,
			DocumentTypeEnum.C_20,
			DocumentTypeEnum.C_21,
			DocumentTypeEnum.C_22,
			DocumentTypeEnum.C_23,
			// DocumentTypeEnum.C_24,
			DocumentTypeEnum.C_25,
			DocumentTypeEnum.C_48,
			DocumentTypeEnum.C_49,
			DocumentTypeEnum.C_52,
			DocumentTypeEnum.C_54,
			DocumentTypeEnum.C_55,
			DocumentTypeEnum.C_58,
			DocumentTypeEnum.C_59,
			DocumentTypeEnum.C_61,
			DocumentTypeEnum.C_63,
			DocumentTypeEnum.C_64,
			DocumentTypeEnum.C_65,
			DocumentTypeEnum.C_66,
			DocumentTypeEnum.C_69,
			DocumentTypeEnum.C_72,
			// DocumentTypeEnum.C_73,
			DocumentTypeEnum.C_75,
			DocumentTypeEnum.C_76,
			DocumentTypeEnum.C_78,
			DocumentTypeEnum.C_79,
			DocumentTypeEnum.C_82,
			DocumentTypeEnum.C_83,
		],
	},
	{
		id: 3,
		label: '근로자',
		value: MasterInfoEnum.APPLICANT,
		children: [
			PageTypeEnum.UNIT,
			PageTypeEnum.FRANCHISE,
			PageTypeEnum.CHANGE_WORK_PLACE,
			PageTypeEnum.EXTENSION_STAY,
		],
		documentType: [
			DocumentTypeEnum.C_0,
			DocumentTypeEnum.C_13,
			DocumentTypeEnum.C_16,
			DocumentTypeEnum.C_19,
			DocumentTypeEnum.C_21,
			DocumentTypeEnum.C_22,
			// DocumentTypeEnum.C_24,
			DocumentTypeEnum.C_25,
			DocumentTypeEnum.C_26,
			DocumentTypeEnum.C_27,
			DocumentTypeEnum.C_28,
			DocumentTypeEnum.C_29,
			DocumentTypeEnum.C_30,
			DocumentTypeEnum.C_31,
			DocumentTypeEnum.C_32,
			DocumentTypeEnum.C_33,
			DocumentTypeEnum.C_34,
			DocumentTypeEnum.C_35,
			DocumentTypeEnum.C_36,
			DocumentTypeEnum.C_37,
			DocumentTypeEnum.C_38,
			DocumentTypeEnum.C_39,
			DocumentTypeEnum.C_40,
			DocumentTypeEnum.C_41,
			DocumentTypeEnum.C_42,
			DocumentTypeEnum.C_43,
			DocumentTypeEnum.C_44,
			DocumentTypeEnum.C_45,
			DocumentTypeEnum.C_46,
			DocumentTypeEnum.C_47,
			DocumentTypeEnum.C_48,
			DocumentTypeEnum.C_49,
			DocumentTypeEnum.C_51,
			DocumentTypeEnum.C_52,
			DocumentTypeEnum.C_53,
			DocumentTypeEnum.C_55,
			DocumentTypeEnum.C_58,
			DocumentTypeEnum.C_59,
			DocumentTypeEnum.C_61,
			DocumentTypeEnum.C_62,
			DocumentTypeEnum.C_63,
			DocumentTypeEnum.C_67,
			DocumentTypeEnum.C_68,
			DocumentTypeEnum.C_72,
			DocumentTypeEnum.C_74,
			DocumentTypeEnum.C_75,
			DocumentTypeEnum.C_76,
			DocumentTypeEnum.C_77,
			DocumentTypeEnum.C_78,
			DocumentTypeEnum.C_79,
			// DocumentTypeEnum.C_82,
			DocumentTypeEnum.C_83,
		],
	},
	{
		id: 4,
		label: '추천자',
		value: MasterInfoEnum.RECOMMENDER,
		children: [
			PageTypeEnum.UNIT,
			PageTypeEnum.APPLICANT,
			PageTypeEnum.FRANCHISE,
		],
		documentType: [
			DocumentTypeEnum.C_0,
			DocumentTypeEnum.C_4,
			DocumentTypeEnum.C_16,
			DocumentTypeEnum.C_26,
			DocumentTypeEnum.C_27,
			DocumentTypeEnum.C_28,
			DocumentTypeEnum.C_29,
			DocumentTypeEnum.C_30,
			DocumentTypeEnum.C_31,
			DocumentTypeEnum.C_32,
			DocumentTypeEnum.C_33,
			DocumentTypeEnum.C_34,
			DocumentTypeEnum.C_35,
			DocumentTypeEnum.C_36,
			DocumentTypeEnum.C_37,
			DocumentTypeEnum.C_49,
			DocumentTypeEnum.C_54,
			DocumentTypeEnum.C_74,
			// DocumentTypeEnum.C_82,
			DocumentTypeEnum.C_83,
		],
	},
	{
		id: 5,
		value: MasterInfoEnum.LODGING,
		label: '숙소',
		children: [
			PageTypeEnum.UNIT,
			PageTypeEnum.APPLICANT,
			PageTypeEnum.FRANCHISE,
			PageTypeEnum.CHANGE_WORK_PLACE,
			PageTypeEnum.EXTENSION_STAY,
		],
		documentType: [
			DocumentTypeEnum.C_0,
			DocumentTypeEnum.C_16,
			DocumentTypeEnum.C_49,
			DocumentTypeEnum.C_54,
		],
	},
];

export const getRelativeOptions = (pageType: PageTypeEnum) => {
	return RELATED_INFO_OPTIONS.filter(
		({ value }) => !includes(pageType, [PageTypeEnum.UNIT])
	).map(({ value, label }) => ({ value, label }));
};

export const getRelativeOptionsByDocumentType = (
	documentType?: DocumentTypeEnum
) => {
	return RELATED_INFO_OPTIONS.filter(
		({ documentType: optionDocumentTypes }) => {
			// If documentType is provided, filter by documentType
			if (
				documentType &&
				optionDocumentTypes &&
				optionDocumentTypes.length > 0
			) {
				return optionDocumentTypes.includes(documentType);
			}

			// If no documentType provided, return all options
			return true;
		}
	).map(({ value, label }) => ({ value, label }));
};

export const getDocuments = (
	pageType: PageTypeEnum,
	isForeign: boolean = false
) => {
	return ALL_DOCUMENT_OPTIONS.filter(({ parents }) =>
		parents.includes(pageType)
	).map(({ value, label, labelEn, labelByPage }) => {
		return {
			value,
			label: isForeign ? labelEn : labelByPage?.[pageType] ?? label,
		};
	});
};

export const getColumns = (
	baseDocumentTypes: DefaultOptionType[],
	pageType: PageTypeEnum,
	isForeign: boolean = false,
	t: TFunction<'documentArea', undefined>
): ColumnTypes => [
	{
		width: 234,
		align: 'center',
		title: t('document'),
		dataIndex: 'documentType',
		key: 'documentType',
		editable: true,
		cellType: EditableCellType.DROPDOWN,
		dropdownProps: {
			optionsByRecord: (record) => {
				const existInBase = baseDocumentTypes
					.map((item) => item.value)
					.includes(record.documentType);

				if (existInBase) {
					return baseDocumentTypes.sort(
						sortByFieldAndLanguage('label', isForeign === true ? 'en' : 'ko')
					);
				}
				const additionalOptions = ALL_DOCUMENT_OPTIONS.filter(
					(doc) => doc.value === record.documentType
				).map((doc) => ({
					value: doc.value,
					label: isForeign
						? doc.labelEn
						: doc.labelByPage?.[pageType] ?? doc.label,
				}));
				return [...baseDocumentTypes, ...additionalOptions].sort(
					sortByFieldAndLanguage('label', isForeign === true ? 'en' : 'ko')
				);
			},
			showSearch: true,
			ignoreSubmitKeys: ['documentType'],
		},
	},
	{
		width: 234,
		align: 'center',
		title: t('file-type'),
		dataIndex: 'typeName',
		key: 'typeName',
		render: (cellProps, record) => (
			<TypeNameDocument record={record as TDefineDocumentAreaDetailStore} />
		),
	},
	{
		width: 234,
		align: 'center',
		title: t('file'),
		dataIndex: 'name',
		key: 'name',
		editable: true,
		cellType: EditableCellType.TEXT_INPUT,
		inputProps: {
			isUploadFileName: true,
			formatInput: (value) => removeFileNameInvalidChars(value),
			maxLength: 100,
		},
	},

	...insertIf(!isForeign, {
		width: 234,
		title: '연관 정보',
		dataIndex: 'relatedInfo',
		key: 'relatedInfo',
		editable: true,
		renderCell: (cellProps: any) => (
			<RelationDocument {...cellProps} pageType={pageType} />
		),
	}),

	{
		width: 234,
		align: 'center',
		title: t('author'),
		dataIndex: 'registName',
		key: 'registName',
	},
	{
		width: 234,
		align: 'center',
		title: t('registration-date'),
		dataIndex: 'registDt',
		key: 'registDt',
	},
];

export const DEFAULT_DOCUMENT_OPTION: DefaultOptionType[] = [
	{
		value: '',
		label: '서류 전체',
	},
];

export const DEFAULT_ISSUANCE_APPLICATION_OPTION: DefaultOptionType[] = [
	{
		value: '',
		label: '발급·신청별 서류',
	},
];

export const validationSchema: Yup.AnyObjectSchema = Yup.object().shape({
	name: Yup.string()
		.trim()
		.required()
		.test('fileNameLength', FormError.REQUIRED, (value) => {
			if (!value) return false;
			const nameWithoutExtension = value.substring(0, value.lastIndexOf('.'));
			return nameWithoutExtension.length > 0;
		}),
});

export const DEFAULT_SEARCH_DOCUMENT_OPTION: DefaultOptionType[] = [
	{
		value: '',
		label: '전체',
	},
];
